import React from 'react';
import { useUserContext } from "../../store/user_context";

const LogOff = () => {
    const { setUser } = useUserContext();
    
    const handleLogOff = () => {
        setUser(null);
        // Additional logout logic can be added here
    };

    return (
        <>
            <section className="main_content">
                <div className="container">
                    <h1 className="page-title">تسجيل الخروج</h1>
                    <div className="form-group">
                        <p>هل أنت متأكد من تسجيل الخروج؟</p>
                        <button 
                            type="button" 
                            className="btn btn-danger" 
                            onClick={handleLogOff}
                        >
                            تسجيل الخروج
                        </button>
                    </div>
                </div>
            </section>
        </>
    );
};

export default LogOff;

